<template>
    <span v-if="siloData.user.id !== 0" id="moduleloader" @resetModule="reset" :data-state="state"
        :data-slide-direction="transitionName">
        <div class="moduleloader" :data-processing="processing" :data-appstate="appState"
            :data-module-theme="current_module_theme" :style="`transition-duration: ${loadModule}`">
            <div v-if="current_module_data" class="module" :data-active-slide="active_slide" :data-slide-color="current_module_data[active_slide].slide_color ? current_module_data[active_slide].slide_color : 'white'">

                <div class="swipecloser"
                    @touchstart="onTouchStart"
                    @touchmove="onTouchMove"
                    @touchend="onTouchEnd"
                ></div>

                <!-- PUT NAV HERE INSTEAD OF IN SLIDE -->
                <div class="ms__nav c c--content--pad pad--h r r--row-always r--justify-space-between r--halign-center">
                    <div class="ms__nav__back">
                        <button v-if="active_slide !== 0 && current_module_data[active_slide].hide_back_button !== 'true'" @click="prev" class="ms__back link type--pre-header">Back</button>
                    </div>
                    <div class="ms__nav__title">
                        <span v-if="current_module_data[active_slide].hide_topic_title !== 'true'" class="type--pre-header type--pre-header--bold" v-text="navTitle"></span>
                    </div>
                    <div class="ms__nav__close">
                        <button
                            @click="toMenu()"
                            aria-title="Topics Menu"
                            class="ms__close icon icon--close">
                                <Icon name="close" />
                        </button>
                    </div>
                </div>

                <ProgressBar v-if="current_module_data[active_slide].show_progress_bar === 'true'" :countMax="current_module_data[active_slide].progress_bar_max" :countCurrent="current_module_data[active_slide].progress_bar_current" />

                <TransitionGroup :name="transitionName" @leave="leave" @enter="enter" @after-enter="afterEnter"
                    tag="div" style="height:100%">

                    <div v-for="(slide, index) in current_module_data"
                        v-show="active_slide === index"
                        class="module__slide"
                        :class="active_slide === index ? 'active' : 'inactive'"
                        :data-slide="index"
                        :key="index">

                        <!--
                        <ModuleSlideIntro v-if="index == 0" :sd="slide" :index="index" :slides="current_module_data"
                            @next="next" @toMenu="toMenu()" @close="reset()" />
                        -->

                        <ModuleSlide
                            :name="`Slide ${index}`"
                            :sd="slide"
                            :index="index"
                            :slides="current_module_data"
                            :siloData="siloData"
                            :activeSlide="active_slide"
                            :active="active_slide === index && state !== 'inactive' ? true : false"
                            :appState="appState"
                            @processing="setProcessing"
                            @refreshData="refreshData"
                            @setNextOnRefresh="setNextOnRefresh"
                            @next="next"
                            @prev="prev"
                            @toMenu="toMenu()"
                            @close="reset()" />

                    </div>

                </TransitionGroup>

                <div class="ms__bg"></div>

            </div>
        </div>

    </span>
</template>

<script>
import ModuleSlide from '@c/ModuleSlide.vue'
import ModuleSlideIntro from '@c/ModuleSlideIntro.vue'
import Icon from '@c/Icon.vue'
import ProgressBar from '@c/elements/ProgressBar.vue'
const axios = require('axios');

export default {
    components: {
        ModuleSlide,
        ModuleSlideIntro,
        Icon,
        ProgressBar,
    },
    data() {
        return {
            state: "inactive",
            processing: false,
            current_module_data: null,
            current_module_theme: 0,
            active_slide: 0,
            count: 0,
            interval_id: null,
            anims: {
                loadModuleJS: 550,
                hideSpeedJS: 750,
            },
            transitionName: 'show-next',
            nextOnRefresh: false,
            titleOverride: null,
            startY: 0,
            endY: 0,
            minSwipeDistance: 60 // px, tweak as needed
        }
    },
    computed: {
        loadModule() {
            return `${this.anims.loadModuleJS}ms`;
        },
        slidesCorrected() {
            return this.current_module_data !== null ? this.current_module_data.slice(1) : null;
        },
        lastSlide() {
            return this.current_module_data.length - 1;
        },
        navTitle() {
            let returned_title = this.current_module_data[this.active_slide].ancestors[1].title;
            if (this.titleOverride !== null) {
                returned_title = this.titleOverride;
            }
            return returned_title;
        },
    },
    props: {
        appState: String,
        siloData: Object,
    },
    mounted() {
        // Allow access to this script from vanilla js
        window.moduleloader = this;

        // Check for the ?mod=29 query string
        //this.checkForModuleQueryString();
    },
    watch: {
        // Watch for changes in the appState
        // If it gets set to "home" reset it to 0
        // So the next time the user comes back, it's set to page 1
        appState() {
            if (this.appState === "home") {
                setTimeout(() => {
                    console.log('reseting active slide');
                    //this.active_slide = 0;
                    //this.destroy();
                }, this.anims.hideSpeedJS);
            }
        },
        siloData() {
            //console.log('silo data changed');
            if (this.nextOnRefresh !== true) { return }
            console.log('can do next on refresh');
            console.log(this.appState);
            if (this.appState === "module" || this.appState === "module-intro") {
                console.log('can do next');
                this.next();
            }
        },
        /*
        active_slide() {
          if (this.active_slide === 0) { return; }
          // If this is the last slide, push up a zero reset
          if (this.active_slide === this.lastSlide) {
            this.updateLastActiveSlide(module_id, "0");
          }
          if (this.active_slide)
        },
        */
    },
    methods: {
        // Allow the bonus loader to go to the next slide on refresh
        setNextOnRefresh() {
            console.log('setting next on refresh (module loader)');
            this.nextOnRefresh = true;
        },
        destroy() {
            console.log('Destroying module slides!');
            this.current_module_data = null;
            this.current_module_theme = 0;
            this.nextOnRefresh = false;
        },
        checkForModuleQueryString() {
            let urlParams = new URLSearchParams(window.location.search);

            // Pass topic id
            if (urlParams.has('lesson')) {
                console.log('LESSON:', urlParams.get('lesson'));
                this.open(urlParams.get('lesson'), true);
            }

            // Pass topic slug
            /*
            if (urlParams.has('tpc')) {
                this.open(urlParams.get('tpc'), true);
            }
            */
        },
        runOnLoadChecks() {
            let urlParams = new URLSearchParams(window.location.search);

            // Check for query strings
            if (urlParams.has('slug') || urlParams.has('slide')) {
                this.checkForSlideQueryString();
                // If there are none, check for last active slide
            } else {
                //this.checkForLastActiveSlide();
            }
        },
        checkForSlideQueryString() {
            let urlParams = new URLSearchParams(window.location.search);

            // You can use slug to pull up slide
            if (urlParams.has('slug')) {
                let slug = urlParams.get('slug');
                // Look through each slide for the one that has that slug
                this.current_module_data.forEach((slide, i) => {
                    // If we find the matching slug
                    if (slide.slug === slug) {
                        // Set the active slide to the key
                        this.active_slide = i;

                        // if the slide number is greater than 0 set module theme
                        if (i > 0) {
                            // ! LOOK INTO THIS
                            this.$emit('updateState', 'module');
                        }
                    }
                });
            }

            if (urlParams.has('slide')) {
                let int = parseInt(urlParams.get('slide'));
                //this.active_slide = int - 1; // this comes in as a string, it has to be a number
                this.active_slide = int - 1; // this comes in as a string, it has to be a number

                // if the slide number is greater than 0 set module theme
                if (int > 0) {
                    // ! LOOK INTO THIS
                    this.$emit('updateState', 'module');
                }
            }

            this.updateUrl(); // update url
            this.postPageView();
        },
        // Look to see if there is a last active slide for this module
        // NOTE: If this works, I need to make it so that the query
        //       SUPERCEDES THIS, otherwise we won't be able to
        //        navigate directly to a page
        checkForLastActiveSlide() {
            let last_active_slide = this.siloData.user.progress[this.current_module_theme - 1].last_active_slide;
            // Make sure we have a last active slide set
            if (last_active_slide !== "" && last_active_slide !== 0) {
                // Set the current active slide to the last active slide
                this.active_slide = parseInt(last_active_slide);
                // I think I need this here but I'm not sure
                this.$emit('updateState', 'module');

                this.updateUrl(); // update url
                this.postPageView();
            }
        },
        open(id, slug = false, title_override = null) {

            // Adjust override
            this.titleOverride = title_override;

            this.getModule(id, slug);
        },
        getModule(id, slug = false) {

            console.log('geting modules:', id);

            let action = slug === true ? this.siloData.urls.getmodulebyslug : this.siloData.urls.getmodule;

            this.$emit('processing', true);

            axios.post(action, {
                id: id,
            }).then((result) => {
                //console.log('RESULT',result);

                // Remove the first item which is parent
                this.current_module_data = result.data.slice(1);

                // !!! Change this to order?
                this.current_module_theme = this.current_module_data[0].ancestors[1].order;
                //console.log('ORDER', this.current_module_theme);

                // Handle theming (Get rid of?)
                this.updateState('module-intro');

                this.state = 'active'; // show modal

                setTimeout(() => {
                    this.$emit('processing', false);
                }, this.anims.loadModuleJS);

                // Looks for query strings and then looks for last active slide
                this.runOnLoadChecks();

                // start timer
                this.startTimer();

                // Update the url string
                this.updateUrl();

                // Posts the page view
                this.postPageView();

                // Sets the topic to inprogress if it's the first slide
                this.trackProgression();

            }).catch((reason) => {
                console.log(reason);
                setTimeout(() => {
                    this.$emit('processing', false);
                }, this.anims.loadModuleJS);
            });
        },
        next() {
            if (this.nextOnRefresh === true) {
                this.nextOnRefresh = false;
            }
            this.transitionName = 'show-next';
            this.active_slide += 1;
            //this.$emit('refreshData');
            this.trackProgression();
            this.updateUrl();
            this.postPageView();
            this.stopTimer();
            this.startTimer();

            if (this.active_slide > 0) {
                this.$emit('updateState', 'module');
            }
        },
        prev() {
            if (this.nextOnRefresh === true) {
                this.nextOnRefresh = false;
            }
            this.transitionName = 'show-prev';
            this.active_slide -= 1;
            //this.$emit('refreshData');
            this.trackProgression();
            this.updateUrl();
            this.postPageView();
            this.stopTimer();
            this.startTimer();

            if (this.active_slide === 0) {

                this.$emit('updateState', 'module-intro');
            }
        },
        // Not sure this is working
        scrollToTop() {
            document.querySelectorAll('.module__slide.active .ms').forEach((item) => { item.scrollTop = 0; });
        },
        // Reset the module back to starting position
        reset() {
            this.state = 'inactive';

            // NOT SURE HERE
            this.$emit('updateState', 'topic');

            // Just refresh the data whenever we close
            // I think I want to do this somewhere else!
            // this.$emit('refreshData');

            // Set the active slide to 0 after the slider hides itself
            // This way we don't see the transition back to the first slide

            // Check to see if the active slide is the last slide
            let slide_last = this.current_module_data.length - 1;

            // If it is the last slide, show the complete modal
            if (this.active_slide === slide_last) {
                // Emit show module complete
                this.$emit('moduleComplete');

                // THIS FIRES WHENEVER A LESSON IS COMPLETE
                // I NEED TO FIGURE OUT A WAY TO ARBITRARILY RUN FUNCTIONS ON THE LAST SLIDE
                // SO THAT WAY WE CAN PUSH UP DATA WE WANT CHANGED
                console.log('MODULE COMPELTE &&&&&&&&&&&&&&&&&&&', this.active_slide);

                // SET LESSON COMPLETION
                let topic_id = this.current_module_data[this.active_slide].ancestors[1].order;
                let lesson_id = this.current_module_data[this.active_slide].ancestors[0].order
                this.completeTopicLesson(topic_id, lesson_id);

                // SET TOPIC COMPLETION IF APPLICABLE
                // returns the current order for this particular lesson in the parent topic
                let current_lesson_index = this.current_module_data[this.active_slide].ancestors[0].order;

                // returns how many lessons are in the topic
                let total_lesson_count = this.current_module_data[this.active_slide].ancestors[1].children;

                console.log(`current lesson index ${current_lesson_index}, total lesson count ${total_lesson_count}`);

                if (current_lesson_index === total_lesson_count) {
                    console.log('LESSONS COMPLETE #$UEYWIEYIUWEIUIWEUIUW');
                    this.completeTopic(topic_id);
                }
            }

            // Reset clock data
            this.stopTimer();

            setTimeout(() => {
                console.log('reseting active slide');
                this.active_slide = 0;
            }, this.anims.hideSpeedJS);

            // Clear the url
            //window.history.pushState({}, document.title, window.location.pathname);
            let url = new URL(window.location);
            url.searchParams.delete('lesson');
            url.searchParams.delete('slide');
            window.history.pushState({}, '', url);
        },
        // transition group callback when it leaves
        // NOTE: MAY NOT BE NEEDED
        leave() {
            //console.log('LEAVING');
            let event = new CustomEvent('slideLeave', { detail: { current: this.active_slide, direction: this.transitionName } });
            window.dispatchEvent(event);
        },
        // transition group callback after it enters
        // NOTE: MAY NOT BE NEEDED
        enter() {
            //console.log('ENTERING');
            this.scrollToTop();
            let event = new CustomEvent('slideEnter', { detail: { current: this.active_slide, direction: this.transitionName } });
            window.dispatchEvent(event);
            //window.dispatchEvent(this.events.enter, { detail: { current: this.active_slide, direction: this.transitionName } });
        },
        // NOTE: MAY NOT BE NEEDED
        afterEnter() {
            //console.log('AFTER ENTER');
            let event = new CustomEvent('slideAfterEnter', { detail: { current: this.active_slide, direction: this.transitionName } });
            window.dispatchEvent(event);
        },
        // This runs on every page change
        // It allows us to determine when we update module status, 
        // fire event tracking events (future) and slide progression (future)
        trackProgression() {
            console.log('module loader: tracking progression');
            // let module_id = this.current_module_theme;
            let module_id = this.current_module_data[0].ancestors[1].order

            // The progress uses array indexing so topic 2 is actually progress[1] and so on
            let module_status = this.siloData.user.progress[this.current_module_theme - 1].status;
            console.log("current module status", module_status);

            let slide = this.active_slide;
            console.log("current slide", slide);

            // Adjusted for 0 indexing
            //let slide_last = this.current_module_data.length - 1;

            // If not the first or last slide
            /*
            if (slide !== 0 && slide !== slide_last) {
                // Push the last active slide number so we can come back to that
                this.updateLastActiveSlide(module_id, slide);
            }
            */

            // If it is the last slide
            /*
            if (slide === slide_last) {
                // Reset the last active slide so we start at the beginning next time
                this.updateLastActiveSlide(module_id, "0");
            }
            */

            // NOTE: I'm not sure we need in-progress
            if (slide === 0 && module_status !== "in-progress" && module_status !== "complete") {
                console.log('module loader: setting topic to');
                console.log(`setting module ${module_id} to in progress`);
                this.updateTopicStatus(module_id, "in-progress");
                // Post module started event
                this.postTopicStarted();
            }
        },
        // Send data to track where we left off
        // NOTE: This does NOT work on the current multi-tiered iteration of the app
        updateLastActiveSlide(module_id, value) {
            let data = [];
            let key = `meta_t${module_id}_last_active_slide`;
            let data_status = {
                key,
                value
            }
            data.push(data_status);

            axios.post(this.siloData.urls.postuserdata, data).then(response => {
                this.$emit('refreshData');
            });
        },
        // Complete the Lesson
        completeTopicLesson(topic_id, lesson_id) {

            // Check to see if it's already completed
            if (this.siloData.user.progress[topic_id - 1].lessons[lesson_id - 1] === "complete") { console.log('moduleloader: lesson already complete'); return; }

            console.log(`completing lesson: ${lesson_id} in topic: ${topic_id}`);
            let data = [];
            let key = `meta_t${topic_id}_l${lesson_id}_status`;
            let value = "complete";
            let data_status = {
                key,
                value
            }
            data.push(data_status);
            console.log(data);

            axios.post(this.siloData.urls.postuserdata, data).then(response => {
                console.log('status updated!', response.data);
                // refresh our data so we can see changes on the home page
                this.$emit('refreshData');
            });

            // Post lesson completed
            this.postLessonCompleted();
        },
        // Complete the Topic
        completeTopic(topic_id) {

            console.log('module loader: completed topic!');

            // Check to see if it's already completed
            if (this.siloData.user.progress[topic_id - 1].status === "complete") { console.log('moduleloader: topic already complete'); return; }

            let data = [];

            // Set up complete status data
            let key = `meta_t${topic_id}_status`;
            let value = "complete";
            let data_status = {
                key,
                value
            }
            data.push(data_status);

            // Set up completion date data
            let completion_date_key = `meta_t${topic_id}_completion_date`;
            let completion_date_value = new Date(); // date ? not sure of format

            let completion_data = {
                key: completion_date_key,
                value: completion_date_value
            };
            data.push(completion_data);

            console.log(data);

            // Post everything
            axios.post(this.siloData.urls.postuserdata, data).then(response => {
                console.log('status updated!', response.data);
                // refresh our data so we can see changes on the home page
                this.$emit('refreshData');
            });

            // Post topic completed
            this.postTopicCompleted();
        },
        // TODO: MODIFY THIS TO WORK FOR A LESSON OR A TOPIC
        updateTopicStatus(module_id, value) {
            console.log('module loader: update topic started!');

            let data = [];
            let key = `meta_t${module_id}_status`;
            let data_status = {
                key,
                value,
            }
            data.push(data_status);

            // Add a started date value for in progress
            if (value === "in-progress") {
                let completion_data = {
                    key: `meta_t${module_id}_started_date`,
                    value: new Date()
                };
                data.push(completion_data);
            }

            // If we are completing a module, also pass up the date of completion
            if (value === "complete") {
                let completion_date_key = `meta_t${module_id}_completion_date`;
                let completion_date_value = new Date(); // date ? not sure of format

                let completion_data = {
                    key: completion_date_key,
                    value: completion_date_value
                };
                data.push(completion_data);
            }

            console.log(data);

            // axios request here
            axios.post(this.siloData.urls.postuserdata, data).then(response => {
                console.log('status updated!', response.data);
                // refresh our data so we can see changes on the home page
                this.$emit('refreshData');
            });
        },
        updateState(newState) {
            this.$emit('updateState', newState);
        },
        setProcessing(state) {
            console.log('setting processing (module loader)');
            this.$emit('processing', state);
        },
        refreshData(onComplete = null) {
            console.log('refreshing data (module loader)');
            this.$emit('refreshData', onComplete);
        },
        updateLessonUrl() {
            var url = new URL(window.location);
            url.searchParams.set('lesson', this.current_module_data[0].slug);
            window.history.pushState({}, '', url);
        },
        updateUrl() {
            var url = new URL(window.location);
            //console.log('%%%%%%%%%%%%%%%%%', url);

            // ! IF I WANT TO DO FINAL URL STUFF
            // I NEED TO BE ABLE TO PARSE THE URL IN THE OTHER DIRECTION AS WELL
            // IE. TAKE /topic/my-motivations/slide/1
            // AND MAKE THAT GO TO THE RIGHT TOPIC AND SLIDE
            let finalUrl = url.protocol + "//" + url.host;
            let topic = "";
            let slide = "";

            // ! uncomment if using old ID-based method
            //url.searchParams.set('topic', this.current_module_data[0].ID);

            // NEED TO SET THIS AS THE PARENT?
            if (this.current_module_data !== null) {
                url.searchParams.set('lesson', this.current_module_data[0].ancestors[0].slug);
            }

            //topic = "/lesson/" + this.current_module_data[0].slug;

            // Remove the slug if we've got it
            if (url.searchParams.has('slug')) {
                url.searchParams.delete('slug');
            }

            if (this.active_slide === 0) {
                url.searchParams.delete('slide');
            } else {
                url.searchParams.set('slide', this.active_slide + 1);
                //slide = "/slide/" + (parseInt(this.active_slide) + 1);
            }

            //finalUrl += topic + slide;

            window.history.pushState({}, '', url);
            //console.log('updating url to', url);
        },
        postPageView() {
            // Viewed Topic: X > Lesson: Y > Slide: Y (URL)
            let data = {
                type: 'topic',
                moduleNumber: this.navTitle, // Topic title
                moduleTitle: this.current_module_data[0].ancestors[0].title, // Lesson title
                screenNumber: this.active_slide + 1, // Slide number
                url: new URL(window.location),
            };
            window.events.postPageView(data);
        },
        // Post module started event
        postTopicStarted() {
            console.log('POSTING TOPIC STARTED');
            // Started Topic: X
            let topic = this.navTitle;
            let message = `Started Topic: ${topic}`;
            let data = {
                type: 'open',
                message: message,
            };
            window.events.postAction(data);
        },
        // Post lesson completion event
        postLessonCompleted() {
            // Completed Topic: X > Lesson Y
            let topic = this.navTitle;
            let lesson = this.current_module_data[0].ancestors[0].title;
            let message = `Completed Topic: ${topic} > Lesson: ${lesson}`;
            let data = {
                type: 'open',
                message: message,
            };
            window.events.postAction(data);
        },
        // Post topic completion event
        postTopicCompleted() {
            console.log('POSTING TOPIC COMPLETED');
            // Completed Topic: X
            let topic = this.navTitle;
            let message = `Completed Topic: ${topic}`;
            let data = {
                type: 'open',
                message: message,
            };
            window.events.postAction(data);
        },
        toMenu() {
            this.reset();
            // TODO: Update so that it sends you back to the specific topic you came from
            this.$emit('updateState', 'topic');
        },
        // Creates a new timer
        startTimer() {
            console.log('TOPIC TIMER STARTED');
            // Store the interval ID so it can be cleared later
            this.intervalId = setInterval(() => {
                // If we're active, add a second, otherwise don't
                if (window.activeChecker.active === true) {
                    //console.log("%cadding time to topic timer", "color: orange");
                    this.count++;
                } else {
                    //console.log("%cnot adding time to topic timer", "color: blue");
                }
            }, 1000);
        },
        // Stops the current timer and pushes it up to the database
        stopTimer() {
            //console.log('time spent on slide: ', this.count);
            // Clear the interval and stop the counting
            clearInterval(this.intervalId);

            // Pass the current count to the server
            this.postTime(this.count);

            // Reset count
            this.count = 0;
        },
        postTime(time) {
            let data = {
                id: this.siloData.user.id,
                key: `meta_t${this.current_module_theme}_time_total`,
                value: time,
            }
            console.log(data);
            axios.post(this.siloData.urls.posttime, data).then(result => {
                // The progress index starts at zero, so we need to subtrack 1
                let progress_i = this.current_module_theme - 1;
                console.log(progress_i);
                //let now = new Date();
                //console.log('**********************TOPIC TIMER POSTED', time);

                // CLEARING THIS OUT BECAUSE I DON'T THINK WE NEED TO REFRESH HERE
                // UNCOMMENT IF IT CAUSES ISSUES
                //this.$emit('refreshData');

                //console.log('current module theme', this.current_module_theme);
                //console.log('**********************TOTAL TOPIC TIME', this.siloData.user.progress[progress_i].time_total);
                //console.log(result);
            });
        },
        onTouchStart(e) {
            this.startY = e.touches[0].clientY
        },
        onTouchMove(e) {
            this.endY = e.touches[0].clientY
        },
        onTouchEnd() {
            const distance = this.endY - this.startY

            if (distance > this.minSwipeDistance) {
                this.toMenu()
            }

            // reset
            this.startY = 0
            this.endY = 0
        },
    },
}
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";


/*
.module__slide {
    opacity: 0;
    transition: all 2.5s;
    &[data-active="true"] {
        opacity: 1;
    }
}
*/

.ms__bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    height: 100vh;
    pointer-events: none;
    background-color: var(--color-offwhite);
    border-top-left-radius: rem(24px);
    border-top-right-radius: rem(24px);
    transition: all 0.15s;
}

[data-appstate="module-intro"] {
    .ms__bg {
        background-color: var(--color-sp-stardust)
    }
}

.module {
    &[data-slide-color="green"] {
        .ms__nav {
            color: var(--color-white);
        }
        .module {
            * {
                color: var(--color-white);
            }
        }
        .ms__bg {
            background-color: var(--color-sp-green);
        }
    }
    &[data-slide-color="white"] {
        .ms__bg {
            background-color: var(--color-offwhite);
        }
        .ms__nav__close {
            color: var(--color-sp-jade);
        }
    }
    &[data-slide-color="blue"] {
        .ms__bg {
            background-color: var(--color-sp-stardust);
        }
        .ms__nav__close {
            color: var(--color-sp-jade);
        }
    }
}

.show-next-enter-active,
.show-prev-enter-active {
    transition: all 0.4s;

    //position: absolute;
    .ms {
        height: 100%;
        overflow: hidden;
    }

    .ms__wrap {
        transition: all 0.1s;
    }
}

.show-next-leave-active,
.show-prev-leave-active {
    transition: all 0.4s;

    //position: absolute;
    .ms {
        height: 100%;
        overflow: hidden;
    }

    .ms__wrap {
        transition: all 0.1s;
    }
}

.show-next-enter,
.show-prev-leave-to {
    transform: translateX(100%);
}

.show-next-leave-to,
.show-prev-enter {
    transform: translateX(-100%);
}

.show-next-leave-to,
.show-prev-leave-to {
    .ms__wrap {
        opacity: 0;
    }
}

.show-next-enter-to,
.show-prev-enter-to {
    .ms__wrap {
        opacity: 1;
    }
}


#moduleloader {
    display: flex;
    position: fixed;
    top: var(--padding-top-card);
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: $z_top;
}

.moduleloader {
    width: 100%;
    transition-property: all;
    transition-timing-function: $easing_regular;
    transform: translateY(100%);
}

.module {
    height: 100%;
    transition: all 0.15s;
}

#moduleloader {
    &[data-state="active"] {
        pointer-events: inherit;
        .moduleloader {
            transform: translateY(0);
        }
    }
    &[data-state="inactive"] {
        pointer-events: none;
        .moduleloader {
            transform: translateY(120%);
        }
    }
}


// Probably don't need this
.module__slide {
    width: 100vw;
    height: 100%;
    position: absolute;

    >* {
        width: 100vw;
    }
}
</style>